var customSizeRadio = document.querySelector('.custom-form-trigger');
const customForm = document.querySelector('.custom-variant-form');
const closebtn = customForm.querySelector('.popup-close');
const firsttab = customForm.querySelector('#first-btn');
const secondtab = customForm.querySelector('#second-btn');
const nextbtn = customForm.querySelector('#next-btn');
const prevbtn = customForm.querySelector('#prev-btn');
const firstslide = customForm.querySelector('.first-slide');
const secondslide = customForm.querySelector('.second-slide');
const progressbarline = customForm.querySelector('.process-bar-line');
const slidestepcount = customForm.querySelector('.step-dec #current-step');
const percentage = customForm.querySelector('.percentage-dec #current-percentage');
const submitBtn = document.getElementById('submit-btn');
const summaryBox = document.getElementById('measurement-summary');
const summarywrapper = document.querySelector('.custom-measurements-data-summary');
const warningbox = document.querySelector('.wraning-box');
const cancelBtn = document.getElementById('cancel-btn');
const body = document.querySelector('body');


document.addEventListener('DOMContentLoaded', function () {
     
     // Open Popup
   document.addEventListener('change', function (event) {
    const target = event.target;

    // If it's the custom size radio
    if (target.matches('input.custom-form-trigger[type="radio"]')) {

      if (target.checked && customForm && firsttab) {
        customForm.classList.add('active');
        firsttab.classList.add('active');
        secondtab.classList.remove('active');
        firstslide.classList.remove('left-move');
        secondslide.classList.remove('left-move');
        percentage.innerHTML = "50%";
        slidestepcount.innerHTML = "1";
        progressbarline.style.setProperty('--progressbar-width', '50%');
        body.classList.add("scroll-jam");
      }
    }
  });


    // Close Popup
    closebtn.addEventListener('click' , function () {
      customForm.classList.remove('active');
      body.classList.remove("scroll-jam");
    })

    firsttab.classList.add('active');
    percentage.innerHTML = "50%";
    slidestepcount.innerHTML = "1";
    progressbarline.style.setProperty('--progressbar-width', '50%');

    // left-right slide scroll
    nextbtn.addEventListener('click', function() {
      firstslide.classList.add('left-move');
      secondslide.classList.add('left-move');
      firsttab.classList.remove('active');
      secondtab.classList.add('active');
      progressbarline.style.setProperty('--progressbar-width', '100%');
      slidestepcount.innerHTML = "2";
      percentage.innerHTML = "100%";
    })
    prevbtn.addEventListener('click', function() {
      firstslide.classList.remove('left-move');
      secondslide.classList.remove('left-move');
      firsttab.classList.add('active');
      secondtab.classList.remove('active');
      progressbarline.style.setProperty('--progressbar-width', '50%')
      slidestepcount.innerHTML = "1";
      percentage.innerHTML = "50%";
    })
    

    // store data on submit
    submitBtn.addEventListener('click', function (e) {
    e.preventDefault();
      
     let allValid = true;
     const fields = customForm.querySelectorAll('input[type="text"], input[type="number"], textarea');
     let summaryHTML = "<ul>";
     document.getElementById('custome-data').innerHTML = '';
   
     const savedData = {}; // For localStorage



      fields.forEach(field => {
        const value = field.value.trim();

        const isRequired = field.hasAttribute('required');
        if (!value) {
          if (isRequired) {
            allValid = false;
            field.classList.add('input-error');
          }
          return; // Skip optional empty field or invalid required
        }

        // Add the value back to the input's value attribute for persistence
        field.setAttribute('value', value);
         savedData[field.id] = value;

        // Get label text 
        const label = customForm.querySelector(`label[for="${field.id}"]`);
         
        if (label) {
         labelFor = label.getAttribute('for');
        }
          const isNumber = field.type === "number";
          const formattedValue = isNumber ? `${value}"` : value;

        // Build summary list
        summaryHTML += `<li><span class="label-text">${labelFor}:</span> ${formattedValue}</li>`;

        if (value && field.hasAttribute('data-custom-measurement')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${labelFor}]`;
          input.value = formattedValue;
          document.getElementById('custome-data').appendChild(input);
        }
      });

        summaryHTML += "</ul>";
         if (allValid) {
          summaryBox.innerHTML = summaryHTML;
          summarywrapper.style.display = "block"
          customForm.classList.remove('active');
          warningbox.innerHTML = "";
          localStorage.setItem('customFormData', JSON.stringify(savedData));
          localStorage.setItem('customFormSummary', summaryHTML);
          body.classList.remove("scroll-jam");
        } else {
          warningbox.innerHTML = "<p style='color: red;'>Please fill all required fields.</p>";
          summarywrapper.style.display = "none"
        }
    });

    // retrive data if page reload
    const savedValues = JSON.parse(localStorage.getItem('customFormData'));
    const savedSummary = localStorage.getItem('customFormSummary');
     
    if (savedValues) {
      Object.entries(savedValues).forEach(([id, val]) => {
        const input = document.getElementById(id);
        if (input) {
          input.value = val;
          input.setAttribute('value', val);
        }
      });
    }

    if (savedSummary) {
      summaryBox.innerHTML = savedSummary;
      summarywrapper.style.display = "block";
    }

    let wasPageReloaded = false;

    window.addEventListener('load', function () {
      const navEntries = performance.getEntriesByType('navigation');
      wasPageReloaded = navEntries.length > 0 && navEntries[0].type === 'reload';
      body.classList.remove("scroll-jam");
    });

    //Edit measurements
    document.querySelector('.data_edit')?.addEventListener('click', function () {
      const savedValues = JSON.parse(localStorage.getItem('customFormData'));
      if (!savedValues) return;
      originalData = savedValues;
      body.classList.add("scroll-jam");

      Object.entries(savedValues).forEach(([id, val]) => {
        const input = document.getElementById(id);
        if (input) {
          input.value = val;
          input.setAttribute('value', val);
        }
      });
      
        customForm.classList.add('active');

        if (wasPageReloaded) {
          firsttab.classList.add('active'); // Only if reload
        }
        cancelBtn.style.display = "inline-block"; // Show cancel button
      });
      
      cancelBtn.addEventListener('click', function (e) {
        e.preventDefault()
        body.classList.remove("scroll-jam");
      // Restore original summary
      const savedSummary = localStorage.getItem('customFormSummary');
      if (savedSummary) {
        summaryBox.innerHTML = savedSummary;
        summarywrapper.style.display = "block";
      }

      // Hide form
      customForm.classList.remove('active');
      cancelBtn.style.display = "none";
    });



    const anyCustomRadio = document.querySelector('input.custom-form-trigger[type="radio"]');
    if (!anyCustomRadio?.checked) {
      // Clear localStorage
      localStorage.removeItem('customFormData');
      localStorage.removeItem('customFormSummary');

      // Clear summary box
      const summaryBox = document.getElementById('measurement-summary');
      const customData = document.getElementById('custome-data');
      const summaryWrapper = document.querySelector('.custom-measurements-data-summary');

      if (summaryBox) summaryBox.innerHTML = '';
      if (customData) customData.innerHTML = '';
      if (summaryWrapper) summaryWrapper.style.display = 'none';

      // Clear values in form
      const customForm = document.querySelector('.custom-variant-form');
      if (customForm) {
        const fields = customForm.querySelectorAll('input, textarea');
        fields.forEach(field => {
          field.value = '';
          field.removeAttribute('value');
          field.classList.remove('input-error');
        });

        // Remove dynamically created hidden inputs
        const hiddenInputs = customData?.querySelectorAll('input[type="hidden"]') || [];
        hiddenInputs.forEach(input => input.remove());
      }
    }
    
});